export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOAD_USER = 'LOAD_USER';

export const LOAD_INVITATION = 'LOAD_INVITATION';
export const UPDATE_INVITATION = 'UPDATE_INVITATION';

export const LOAD_GUESTS = 'LOAD_GUESTS';
export const UPDATE_GUEST = 'UPDATE_GUEST';
export const SET_ACTIVE_GUEST = 'SET_ACTIVE_GUEST';
export const SET_STEPS = 'SET_STEPS';
export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
export const UPDATE_GUEST_FORM = 'UPDATE_GUEST_FORM';
export const ADD_GUEST_DOCUMENT = 'ADD_GUEST_DOCUMENT';
export const REMOVE_GUEST_DOCUMENT = 'REMOVE_GUEST_DOCUMENT';

export const LOAD_DIETARY = 'LOAD_DIETARY';
export const LOAD_LANGUAGES = 'LOAD_LANGUAGES';
export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';

export const SET_CURRENT_LANGUAGE = 'SET_CURRENT_LANGUAGE';

export const SET_MY_ACCOUNT_POPUP_STATUS = 'SET_MY_ACCOUNT_POPUP_STATUS';
export const SET_POPUP_NAVIGATION_STATUS = 'SET_POPUP_NAVIGATION_STATUS';

export const SET_REDIRECT = 'SET_REDIRECT';

export const UPDATE_IS_MOBILE = 'UPDATE_IS_MOBILE';
